// @ts-check
import { hasValuesInLocalStorage, paramValues } from './paramValues';

/**
 * @type {Record<import('./types').PiniaStoresMigrations,
 * Record<string, import('./storeParams').ParameterKeys>>}
 */
const paramsToMigrate = {
  appConfig: {
    allowSettingWorkEnvironment: 'PermitirEstablecerEntornoDeTrabajo',
    forceInformationBarVisibility: 'ForzarVisibilidadBarraInformativa',
  },
  alhondigas: {
    permitirVenderPartidasMultiplesVentas: 'PermitirVenderPartidasMultiplesVentas',
    lecturaContinuaPartidasEnListinSubasta: 'LecturaContinuaPartidasEnListinSubasta',
    maximoNumeroListinesAbiertos: 'MaximoNumeroListinesAbiertos',
  },
  appOrders: {
    unidadesLogisticasEnProducion: 'UnidadesLogisticasEnProducion',
    filtrarPedidosVentaVendedorAPP: 'FiltrarPedidosVentaVendedorAPP',
  },
  commercialisation: {
    disallowLocationAdvancement: 'NoPermitirAvanzarEnGestionUbicacionesAPP',
    RecuentoACiegasAPP: 'RecuentoACiegasAPP',
  },
  contracts: {
    BloquearEnvioContratosNoConfirmados: 'BloquearEnvioContratosNoConfirmados',
    PrefijoCodigoFinca: 'PrefijoCodigoFinca',
  },
  expeditions: {
    ParamERPEliminarReservaAnteriorExpediciones: 'EliminarReservaAnteriorExpediciones',
    lecturaContinuaCargasExpediciones: 'LecturaContinuaCargasExpediciones',
    introduccionManualCBLecturaPalesExpeciones: 'IntroduccionManualCBLecturaPalesExpeciones',
    permitirMoverPalesReservadosEnOrdenCarga: 'PermitirMoverPalesReservadosEnOrdenCarga',
  },
  presence: {
    NoPermitirModificarMarcajePresencia: 'NoPermitirModificarMarcajePresencia',
    PermitirReiniciarServicioCapturaMarcajesAPP: 'PermitirReiniciarServicioCapturaMarcajesAPP',
    workingDayStartHour: 'HoraInicioJornada',
    PrefijoTrabajadoresAlmacen: 'PrefijoTrabajadoresAlmacen',
  },
  production: {
    mantenerReservaPaleOrigenTraspasoMovilidad: 'MantenerReservaPaleOrigenTraspasoMovilidad',
    showPresenceShifts: 'MostrarTurnosPresencia',
  },
  repairParts: {
    partStatusCreatedWorkshop: 'EstadoDefectoPartesReparacion',
    partStatusCreatedStreet: 'EstadoDefectoPartesReparacionCalle',
    partStatusRouteStarted: 'EstadoParteReapracionInicioDesplazamiento',
    partStatusStarted: 'EstadoParteReparacionEnCliente',
    partStatusValued: 'EstadoValoracionDefectoParteReparacion',
    partStatusFinished: 'EstadoFinalizacionDefectoParteReparacion',
    defaultProductionActivity: 'ActividadProduccionDefectoReparaciones',
    defaultRepairsLocation: 'TipoLugarReparacionPorDefecto',
    defaultProductionLine: 'LineaProduccionDefectoReparaciones',
    consumedInterventionsArticle: 'ArticuloConsumoReparacion',
    consumedDisplacementArticle: 'ArticuloConsumoDesplazamiento',
    isAllowedConsumedArticlesQuantityModification: 'PermitirModificarCantidadArticulosConsumidosReparaciones',
    isAllowedMultipleDaysRouteOperation: 'PermitirTrayectosMultiplesDiasParteReparacion',
  },
  traceability: {
    PermitirCrearOrdenYParteDeProduccionPorPedidoEnMovilidad: 'PermitirCrearOrdenYParteDeProduccionPorPedidoEnMovilidad',
    registrarDestrioEnVolcado: 'RegistrarDestrioEnVolcado',
    BloquearFinPaletSinDatosOrigen: 'BloquearFinPaletSinDatosOrigen',
    usoLotesMovilidad: 'UsoLotesMovilidad',
    actualizarLineasNumeroSerieVolcado: 'ActualizarLineasNumeroSerieVolcado',
    RestaurarTipoEnvasadoPaletizadoMultiple: 'RestaurarTipoEnvasadoPaletizadoMultiple',
    // ocultarRegistroCajas: 'OcultarRegistroCajas',
    usarRepartoDeTrabajadoresLineaProduccionProporcional: 'NumeroTrabajadoresManualLineasProduccionLineaPedido',
    ActualizarConfeccionPrevistaFamiliaGenericaPedido: 'ActualizarConfeccionPrevistaFamiliaGenericaPedido',
    lecturaContinuaUbicacionesAPP: 'LecturaContinuaUbicacionesAPP',
    // articuloTipoEnvaseDefectoPrecalibrado: 'ArticuloTipoEnvaseDefectoPrecalibrado',
    // articuloTipoPaleDefectoPrecalibrado: 'ArticuloTipoPaleDefectoPrecalibrado',
    ubicacionDefectoEntrada: 'UbicacionDefectoEntrada',
    comprobarConfeccionCajaEnMovilidad: 'ComprobarConfeccionCajaEnMovilidad',
    envasadoPorDefectoMarca: 'EnvasadoPorDefectoMarca',
    // envasadoPorDefectoPalet: 'EnvasadoPorDefectoPalet',
    envasadoPorDefectoPaletRecoleccion: 'EnvasadoPorDefectoPaletRecoleccion',
    trabajarConNumerosDeSerie: 'trabajarConNumerosDeSerie',
    mostrarDatosAuxiliaresLineaPedidoVenta: 'mostrarDatosAuxiliaresLineaPedidoVenta',
    datosComplementariosAObtener: 'DatosComplementariosAObtener',
    imprimirEtiquetaRecuperadoVolcado: 'ImprimirEtiquetaRecuperadoVolcado',
    comprobarCompatibilidadVolcadoAPedido: 'ComprobarCompatibilidadVolcadoAPedido',
    validarPartidasAnterioresVolcado: 'ValidarPartidasAnterioresVolcado',
    replanificarCantidadPaleTraspasadoOReprocesado: 'ReplanificarCantidadPaleTraspasadoOReprocesado',
  },
};

export function migrateParamsFromPinia() {
  if (hasValuesInLocalStorage()) {
    // The parameters have already been migrated
    return;
  }

  for (const [storeName, paramMappings] of Object.entries(paramsToMigrate)) {
    const storageParams = localStorage.getItem(storeName);

    if (storageParams) {
      const parsedParams = /** @type {Partial<Record<string, never>>} */ (JSON.parse(storageParams));

      for (const [name, key] of Object.entries(paramMappings)) {
        if (Object.hasOwn(parsedParams, name)) {
          paramValues[key].value = /** @type {never} */ (parsedParams[name]);
        }
      }
    }
  }
}
